module.exports = __webpack_public_path__ + "media/images/icon_close2-1848f483cb2b7902495ceed1a585b6d7.svg";